$(document).ready(function() {
  $('.js-toggle-mobile-navigation').on('click', function(evt) {
    evt.preventDefault();
    $('#navigation-modal').addClass('open');
    $('body').addClass('overflow-hidden');
    return false;
  });

  $('.close-navigation-modal').on('click', function(evt) {
    evt.preventDefault();
    $('#navigation-modal').removeClass('open');
    $('body').removeClass('overflow-hidden');
    return false;
  })

  $(function() {
    $('.js-plus-minus-toggle').on('click', function() {
      $(this).toggleClass('more-opened');
      $(this).find('.plus-minus-toggle').toggleClass('collapsed more-opened');
    });
  });
});


